module.exports = {"title":{"ja":"解除が完了しました","en":"Unsynchronized Complete"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/confirmation/cooperation/release/release.json
// module id = oP/F
// module chunks = 1